import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=3d5e5f20&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5e5f20",
  null
  
)

export default component.exports